import { createGlobalStyle } from 'styled-components'

import { getLauncherVisibilityStyles, useIsSupportSlideOverOpen } from './launcherVisibility'

const HubSpotLauncherGlobalStyle = createGlobalStyle<{ $isHidden: boolean }>`
  #hubspot-messages-iframe-container {
    ${({ $isHidden }) => getLauncherVisibilityStyles({ $isHidden })}
  }
`

export function HubSpotLauncherStyle() {
  return <HubSpotLauncherGlobalStyle $isHidden={useIsSupportSlideOverOpen()} />
}
